module.exports = __webpack_public_path__ + "static/media/tag.10b7880e.svg";